function isDefined(element) {
	return ( typeof element !== typeof undefined );
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires=" + d.toUTCString();

	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name          = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca            = decodedCookie.split(';');
	
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];

		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}

	return null;
}

/*
 * Stops execution for "ms" millisenconds
 * !! ATTENTION: use .then(() => <your_code_here>) for subsequent instructions
 */
function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

/* Debounce function */
const debounce = (fn, delay = 1000) => {
    let timerId = null;

    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => fn(...args), delay);
    };
};

function lockPageScroll() {
	if (!document.body.classList.contains('--scroll-locked')) {
		const scrollY = window.scrollY;

		document.body.setAttribute('data-scroll-position', scrollY);
		document.body.classList.add('--scroll-locked');
		document.body.style.position = 'fixed';
		document.body.style.width = '100%';
		document.body.style.top = '-' + scrollY + 'px';
		document.body.style.overflow = 'hidden';
	}
}

function unlockPageScroll() {
	if (document.body.classList.contains('--scroll-locked')) {
		const scrollY = parseInt(document.body.getAttribute('data-scroll-position') || '0');

		// Temporarily disable smooth scroll to prevent visible jump
		document.documentElement.style.scrollBehavior = 'auto';

		document.body.classList.remove('--scroll-locked');
		document.body.style.position = '';
		document.body.style.width = '';
		document.body.style.top = '';
		document.body.style.overflow = '';

		window.scrollTo(0, scrollY);

		// Re-enable smooth scroll on next frame
		requestAnimationFrame(() => {
			document.documentElement.style.scrollBehavior = '';
		});
	}
}

const desktopScreen = window.matchMedia("(min-width: 1025px)")
  , tabletLandscape = window.matchMedia("(min-width: 992px) and (max-width: 1024px)");

/*
 * Main entry point for JS handlers on different pages
 */
document.addEventListener('DOMContentLoaded', e => {
	// Refresh automatic banners in Products archive page
	if (document.querySelectorAll('.banner').length > 0) {
		refreshBanners();
	}

	// Flyout menu controls
	if (document.getElementById('flyout-open')) {
		document.getElementById('flyout-open').addEventListener('click', (evt) => {
			lockPageScroll();
			document.body.classList.add('--flyout-open');
		});
	}

	if (document.getElementById('flyout-close')) {
		document.getElementById('flyout-close').addEventListener('click', (evt) => {
			document.body.classList.remove('--flyout-open');
			unlockPageScroll();
		});
	}

	// TEMP code for double background colors
	let bgBreak = document.querySelector('.bg-break');

	if (bgBreak != null) {
		const r      = document.querySelector(':root');
		let bgHeight = document.body.clientHeight - bgBreak.offsetTop;

		r.style.setProperty('--bg-height', bgHeight + 'px');
	}

	// GSAP plugins loading
	gsap.registerPlugin(ScrollTrigger);

	// Header animation
	const headerShowHide = gsap.from('header', { 
		y: "-100%",
		paused: true,
		duration: 0.4,
		delay: 0.2
	}).progress(1);
	
	ScrollTrigger.create({
		start: 80, //"top top-=8rem",
		end: 99999,
		onUpdate: (self) => {
			if (!document.body.classList.contains('--flyout-open') && !document.body.classList.contains('--search-open') && !document.body.classList.contains('--scroll-locked')) {
				if (self.direction === -1) {
					document.body.classList.add('--scroll-up');
					document.body.classList.remove('--scroll-down');
					headerShowHide.play();
				}
				else {
					document.body.classList.add('--scroll-down');
					document.body.classList.remove('--scroll-up');
					headerShowHide.reverse();
				}
			}
		}
	});	
	
	// Fade in content animation
	initDeferAnimation();

	// Footer animation
	let footer = document.querySelector('footer');

	if (footer) {
		gsap.from(footer, {
			scrollTrigger: {
				start: "top bottom",
				end: "bottom bottom",
				trigger: footer,
				//toggleClass: '--in-view',
				onEnter: () => {
					document.body.classList.add('--footer-in');
					document.querySelector('footer').classList.add('--in-view');

					if (document.body.classList.contains('--filters-open')) {
						document.querySelector('.filters-panel').classList.remove('--open');
						document.querySelector('.filters-panel').classList.remove('--filters-open');
					}
				},
				onLeaveBack: () => {
					document.body.classList.remove('--footer-in');
					document.querySelector('footer').classList.remove('--in-view');
				},
			}
		}); 
	}

	/*
	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: "footer",
			pin: false,
			start: "top bottom-=100px",
			end: "bottom bottom",
			scrub: false,
			toggleClass: "pippo"
		}
	});
	*/

	// Geoip banner
	if (document.querySelectorAll('.geoip-toggle')) {
		document.querySelectorAll('.geoip-toggle').forEach( (item) => {
			item.addEventListener('click', (evt) => {
				document.body.classList.remove('--geoip-open');
				setCookie('geoip-dismiss', true, 30);
			});
		});
	}
});